import { useState } from "react";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";

/**
 * Variant B for derivable survey questions: the client answers the QUESTION in
 * its own vocabulary (Yes/No or a count) instead of guessing our severity
 * ladder. The server derives is-deficiency/severity by running the answer
 * through the same rule-pack mapping our own pipeline uses.
 */
export function AnswerControls({
  question,
  onSubmit,
  busy,
}: {
  question: { title: string; answer_kind: "boolean" | "count" };
  onSubmit: (d: { clientAnswer?: string | number; clientCantAssess?: boolean }) => void;
  busy?: boolean;
}) {
  const [count, setCount] = useState("");

  const cantTell = (
    <Button
      variant="ghost"
      disabled={busy}
      onClick={() => onSubmit({ clientCantAssess: true })}
      className="text-muted-foreground"
    >
      Can't tell — poor image
    </Button>
  );

  if (question.answer_kind === "boolean") {
    return (
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">{question.title}</p>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" disabled={busy} onClick={() => onSubmit({ clientAnswer: "Yes" })}>
            Yes
          </Button>
          <Button variant="outline" disabled={busy} onClick={() => onSubmit({ clientAnswer: "No" })}>
            No
          </Button>
          {cantTell}
        </div>
      </div>
    );
  }

  const n = Number(count);
  const valid = count.trim() !== "" && Number.isInteger(n) && n >= 0;
  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">{question.title}</p>
      <div className="flex flex-wrap items-center gap-2">
        <Input
          type="number"
          min={0}
          step={1}
          value={count}
          onChange={(e) => setCount(e.target.value)}
          disabled={busy}
          placeholder="How many?"
          className="w-32"
        />
        <Button variant="outline" disabled={busy || !valid} onClick={() => onSubmit({ clientAnswer: n })}>
          Submit
        </Button>
        {cantTell}
      </div>
    </div>
  );
}
